import { Icon, IconName } from "@zapier/zinnia-icons";
import { Heading, SkeletonBlock } from "@zapier/design-system";
import style from "./FolderHeaderTitle.module.css";

interface Props {
  title: string;
  isFoldersLoading?: boolean;
  isShared?: boolean;
  icon?: IconName;
}

const FolderHeaderTitle = ({
  title,
  isFoldersLoading,
  isShared,
  icon,
}: Props) => {
  return (
    <div className={style.titleWrapper} data-testid="FolderHeaderTitle">
      <Icon
        name={icon || (isShared ? "team" : "navFolder")}
        size={36}
        aria-hidden={true}
      />
      {isFoldersLoading ? (
        <span className={style.skeletonWrapper}>
          <SkeletonBlock width={300} height={24} />
        </span>
      ) : (
        <Heading className={style.heading}>{title}</Heading>
      )}
    </div>
  );
};

export default FolderHeaderTitle;
